export default __webpack_public_path__ + "static/media/Label.768b13c3.svg";